import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ResendButton = ({ onResend, loading, cooldown, success, error }) => {
  const isDisabled = loading || cooldown > 0;

  return (
    <div className="mb-8">
      <Button
        onClick={onResend}
        disabled={isDisabled}
        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
      >
        {loading ? (
          <>
            <Icon name="Loader" className="w-5 h-5 mr-2 animate-spin" />
            Sending...
          </>
        ) : cooldown > 0 ? (
          <>
            <Icon name="Clock" className="w-5 h-5 mr-2" />
            Resend in {cooldown}s
          </>
        ) : (
          <>
            <Icon name="Mail" className="w-5 h-5 mr-2" />
            Resend Verification Email
          </>
        )}
      </Button>

      {/* Success Message */}
      {success && (
        <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg flex items-start">
          <Icon name="CheckCircle" className="w-5 h-5 text-green-600 mr-3 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-semibold text-green-800">Email sent successfully!</p>
            <p className="text-sm text-green-700 mt-1">
              Please check your inbox. It may take a few minutes to arrive.
            </p>
          </div>
        </div>
      )}

      {/* Error Message */}
      {error && (
        <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-lg flex items-start">
          <Icon name="AlertCircle" className="w-5 h-5 text-red-600 mr-3 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-semibold text-red-800">Failed to send email</p>
            <p className="text-sm text-red-700 mt-1">{error}</p>
          </div>
        </div>
      )}

      {/* Cooldown Info */}
      {cooldown > 0 && (
        <p className="text-sm text-gray-500 text-center mt-3">
          To prevent spam, you can request a new email every 60 seconds.
        </p>
      )}
    </div>
  );
};

export default ResendButton;